import {
  Paper,
  Typography,
  Button,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { isProductView, isSelectionMode, type ProductSelectionMode } from './types';

interface ProductEmptyStateProps {
  hasFilters: boolean;
  selectionMode: ProductSelectionMode;
  onCreateProduct: () => void;
}

export const ProductEmptyState = ({
  hasFilters,
  selectionMode,
  onCreateProduct,
}: ProductEmptyStateProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, sm: 6 },
        textAlign: 'center',
        backgroundColor: 'background.default',
        border: '1px dashed',
        borderColor: 'divider',
      }}
    >
      <Typography variant="h5" gutterBottom>
        Продукти не знайдено
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {hasFilters
          ? 'Спробуйте змінити фільтри пошуку'
          : isSelectionMode(selectionMode)
          ? 'Немає продуктів для вибору. Поверніться і створіть продукт спочатку.'
          : 'Створіть свій перший продукт, щоб почати'}
      </Typography>
      {isProductView(selectionMode) && !hasFilters && (
        <Button
          variant="contained"
          size="large"
          startIcon={<AddIcon />}
          onClick={onCreateProduct}
        >
          Створити
        </Button>
      )}
    </Paper>
  );
};
